import { render, staticRenderFns } from "./SalesUnitForm.vue?vue&type=template&id=b723058e&"
import script from "./SalesUnitForm.vue?vue&type=script&lang=js&"
export * from "./SalesUnitForm.vue?vue&type=script&lang=js&"
import style0 from "./SalesUnitForm.vue?vue&type=style&index=0&id=b723058e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports